<template>
  <div class="qrcode-content">
    <div class="header">{{ selectedStoreConfig.title }}</div>
    <div class="qrcode-wrap">
      <div class="item qr-url">
        <div class="left">
          <img :src="selectedStoreConfig.previewUrl" alt="" class="qrcode" />
        </div>
        <div class="right">
          <div class="text1" v-if="storeQrList.length === 1">台卡二维码</div>
          <el-select v-else v-model="qrcodeMode">
            <el-option
              v-for="item in storeQrList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="text2">
            {{ selectedStoreConfig.hint }}
          </div>
          <div class="text3">
            彩色打印
            <span>148*210mm</span>
          </div>
          <el-button
            class="download"
            @click="qrcodeMode === 2 ? handleDownload('table-special') : handleDownload('table')"
          >
            下载
          </el-button>
        </div>
      </div>
      <div class="item post-url">
        <div class="left">
          <img :src="bg" alt="" class="qrcode" />
        </div>
        <div class="right">
          <div class="text1">海报二维码</div>
          <div class="text2">建议粘贴在药品货架、墙上使用</div>
          <div class="text3">
            彩色打印
            <span>594x841mm</span>
          </div>
          <el-button class="download" @click="handleDownload('poster')">下载</el-button>
        </div>
      </div>
    </div>
    <div class="header">扫码问诊用户操作手册</div>
    <div class="book-wrap">
      <div class="item guideline-url">
        <div class="left">
          <img :src="bgGuide" alt="" class="qrcode" />
        </div>
        <div class="right">
          <div class="text1">智云问诊《扫码问诊用户操作手册》</div>
          <div class="text2">操作指南指导用户操作的小册子</div>
          <el-button class="download" @click="handleDownload('guideline')">下载</el-button>
        </div>
      </div>
    </div>
    <div id="stage" style="display: none"></div>
  </div>
</template>

<script>
// import { Loading } from 'element-ui';
import Konva from 'konva';
import { download } from '@/util';
import poster from '@/assets/img/shopmanager/bg-poster.jpg';
import table from '@/assets/img/shopmanager/bg-table.jpg';
import bg from '@/assets/img/shopmanager/bg.jpg';
import tableBg from '@/assets/img/shopmanager/table.jpg';
import bgGuide from '@/assets/img/shopmanager/guideline.jpg';
import supervisionImg from '@/assets/img/shopmanager/supervision.jpg';
import supervisionBg from '@/assets/img/shopmanager/supervisionBg.jpg';
import cqPreview from '@/assets/img/shopmanager/cq-preview.jpg';
import qrcode from 'qrcode';

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export default {
  props: ['wxQrUrl', 'storeName', 'medicalQrUrl', 'guidelineUrl', 'storeSupervision', 'storeQrList'],
  data: function () {
    return {
      bg, // 海报二维码预览背景
      bgGuide, // 用户手册背景
      tableBg, // 台卡二维码预览背景
      supervisionImg, // 药监三合一背景
      supervisionBg, // 药监三合一预览
      cqPreview, // 重庆预览
      loading: null,
      // 生成海报相关参数
      poster: {
        width: 7016,
        height: 9933,
        background: {
          width: 7016,
          height: 9933,
          x: 0,
          y: 0,
          value: poster
        },
        qrcode: {
          x: 459,
          y: 8977,
          width: 720,
          height: 720
        },
        text: {
          x: 990,
          y: 2625,
          width: 5036,
          height: 672,
          align: 'center',
          text: '',
          fontSize: 240,
          fill: '#262626',
          lineHeight: 1.3,
          verticalAlign: 'middle',
          limitCount: 40
        }
      },
      qrcodeMode: 0,
      // 生成桌面二维码相关参数
      supervision: {
        width: 1748,
        height: 2480,
        x: 0,
        y: 0,
        background: {
          width: 1748,
          height: 2480,
          x: 0,
          y: 0,
          value: supervisionImg
        },
        qrcode: {
          x: 571,
          y: 1242,
          width: 600,
          height: 600
        },
        title: {
          width: 1748,
          x: 0,
          y: 170,
          fontSize: 148,
          fontStyle: 'bold',
          text: '智云数字药监',
          align: 'center',
          height: 195,
          fill: '#fff',
          fontFamily: 'Microsoft YaHei',
          lineHeight: 1.3,
          limitCount: 10
        },
        subTitle: {
          width: 1748,
          x: 0,
          y: 350,
          height: 195,
          fontSize: 148,
          fontStyle: 'bold',
          fontFamily: 'Microsoft YaHei',
          align: 'center',
          text: '预警系统',
          fill: '#fff',
          lineHeight: 1.3,
          limitCount: 10
        },
        text: {
          x: 486,
          y: 1028,
          width: 770,
          height: 136,
          align: 'center',
          text: '',
          fontSize: 48,
          fill: '#262626',
          lineHeight: 1.3,
          limitCount: 32
        }
      }
    };
  },
  computed: {
    selectedStoreConfig() {
      const { qrcodeMode, adaptStoreQrList } = this;
      return adaptStoreQrList.find(o => o.value === qrcodeMode) || {};
    },
    table() {
      const { selectedStoreConfig } = this;
      return {
        width: 1748,
        height: 2480,
        x: 0,
        y: 0,
        background: {
          width: 1748,
          height: 2480,
          x: 0,
          y: 0,
          value: selectedStoreConfig.backgroundUrl
        },
        qrcode: {
          x: 571,
          y: 1242,
          width: 600,
          height: 600
        },
        text: {
          x: 486,
          y: 1028,
          width: 770,
          height: 136,
          align: 'center',
          text: '',
          fontSize: 48,
          fill: '#262626',
          lineHeight: 1.3,
          limitCount: 32
        }
      };
    },
    adaptStoreQrList() {
      const { storeQrList, storeSupervision, supervisionBg } = this;

      return storeQrList.map(o => {
        const supervisionProps = {
          previewUrl: supervisionBg,
          backgroundUrl: supervisionImg,
          title: '药店二维码',
          hint: '扫码后可进行药品登记/处方申请，建议放置在收银台使用'
        };

        if (o.value === 0 && storeSupervision.cardIsShow) {
          return {
            ...o,
            ...supervisionProps
          };
        }
        return { ...o, title: '扫码问诊二维码', hint: '建议放置在收银台使用' };
      });
    }
  },
  mounted() {
    this.qrcodeMode = this.storeQrList?.[0].value;
  },
  methods: {
    downloadCanvas(imgData, fileName) {
      const link = document.createElement('a');
      const blob = dataURLtoBlob(imgData);
      const objUrl = URL.createObjectURL(blob);
      link.download = fileName;

      link.href = objUrl;

      link.click();
    },
    async handleDownload(type) {
      this.loading = this.$loading({
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0)'
      });
      try {
        switch (type) {
          case 'guideline':
            if (!this.guidelineUrl) {
              this.$message.error('未配置用户手册');
              break;
            }
            download(this.guidelineUrl, '小程序用户操作手册.pdf');
            break;
          case 'poster':
            this.downloadCanvas(await this.downloadPic(this.poster), '海报.jpg');
            break;
          case 'table':
            this.downloadCanvas(await this.downloadPic(this.table), '桌卡.jpg');
            break;
          case 'table-special':
            this.downloadCanvas(await this.handleSpecialDownload(), '桌卡.jpg');
            break;
          default:
            break;
        }
      } catch (error) {
        console.log(error);
        this.$message.error('下载失败');
      }
      this.loading.close();
    },
    async downloadPic(type) {
      if (!this.selectedStoreConfig.qrUrl) return this.$message.error('生成二维码异常，请反馈您的业务经理处理');
      const url = this.selectedStoreConfig.qrUrl;

      const { width, height, text, background, qrcode, title, subTitle } = type;
      const taskList = [];
      const stage = new Konva.Stage({
        width,
        height,
        container: 'stage'
      });
      // 添加绘图层
      const layer = new Konva.Layer();
      stage.add(layer);

      // 绘制图片 会被覆盖 暂时先一张一张画
      const drawBg = await drawImage(background);
      if (title) {
        const titleText = drawText({
          ...title,
          text: (this.storeSupervision.supervisionCardTitle || '青神县') + '数字药监'
        });
        taskList.push(titleText);
      }
      if (subTitle) {
        const subTitleText = drawText({
          ...subTitle
        });
        taskList.push(subTitleText);
      }
      const drawQrcode = await drawImage({
        ...qrcode,
        value: url
      });
      taskList.push(drawBg);
      taskList.push(drawQrcode);
      // 绘制文字
      const textPromise = drawText({
        ...text,
        text: this.getTextEllipsisByDrawing(this.storeName, text.limitCount)
      });
      taskList.push(textPromise);

      return new Promise((resolve, reject) => {
        // 所有layer绘制完成后转成图片
        Promise.all(taskList)
          .then(() => {
            // 绘制
            layer.draw();
            // 转成图片
            resolve(stage.toDataURL());
          })
          .catch(err => {
            reject(new Error(err));
          });
      });

      function drawImage(param) {
        return new Promise((resolve, reject) => {
          try {
            const dom = new Image();
            let imageLayer;
            dom.crossOrigin = 'anonymous';
            dom.onload = () => {
              imageLayer = new Konva.Image({
                ...param,
                image: dom
              });
              layer.add(imageLayer);
              resolve(1);
            };
            dom.src = param.value;
          } catch (error) {
            reject(error);
          }
        });
      }
      function drawText(param) {
        const textLayer = new Konva.Text(param);
        layer.add(textLayer);
        return 1;
      }
    },
    getTextEllipsisByDrawing(name = '', count) {
      if (name.length > count) {
        return `${name.slice(0, count - 1)}...`;
      } else {
        return name;
      }
    },
    handleSpecialDownload() {
      return new Promise(async resolve => {
        const { selectedStoreConfig } = this;

        const canvas = await qrcode.toCanvas(selectedStoreConfig.storeInfoJson, {
          width: 500,
          errorCorrectionLevel: 'H',
          margin: 0
        });

        const imageObj = new Image();
        imageObj.crossOrigin = 'anonymous';
        imageObj.onload = e => {
          const { naturalWidth, naturalHeight } = e.target;
          const stage = new Konva.Stage({
            container: 'stage',
            width: naturalWidth,
            height: naturalHeight
          });
          const layer = new Konva.Layer();

          stage.add(layer);

          const image = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,
            width: naturalWidth,
            height: naturalHeight
          });
          const qrImg = new Konva.Image({
            x: 1124,
            y: 1699,
            image: canvas,
            width: 500,
            height: 500
          });

          layer.add(image);
          layer.add(qrImg);
          layer.draw();

          resolve(stage.toDataURL());
        };
        imageObj.src = selectedStoreConfig.backgroundUrl;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.qrcode-content {
  .header {
    font-size: 16px;
    line-height: 16px;
    color: #242424;
    margin-bottom: 12px;
    font-weight: bold;
  }
  .qrcode-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
    max-width: 864px;
  }
  .item {
    overflow: hidden;
    .left {
      width: 176px;
      height: 248px;
      background-color: #f7f7f7;
      float: left;
      margin-right: 15px;
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border: 1px solid #f2f2f2;
    }
    .right {
      float: left;
      font-size: 14px;
      width: 176px;
      height: 234px;
      position: relative;
      .text1 {
        color: #202020;
        margin-bottom: 8px;
      }
      .text2 {
        color: #bdbdbd;
        margin-bottom: 24px;
      }
      .text3 {
        color: #707070;
        span {
          margin-left: 16px;
        }
      }
      .download {
        width: 174px;
        height: 40px;
        border: 1px solid #1e8dff;
        color: #1e8dff;
        text-align: center;
        position: absolute;
        bottom: 16px;
      }
    }
    &.qr-url {
      img {
        width: 100%;
      }
    }
    &.post-url {
      img {
        height: 100%;
      }
    }
    &.guideline-url {
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
}
</style>
